import React from "react";
import "./ContentContainer.css";

function ContentContainer({ children, className = "" }) {
  return (
    <div className={`content-container ${className}`}>
      {children}
    </div>
  );
}

export default ContentContainer;

